// extracted by mini-css-extract-plugin
export default {"List":"List_List__b-n3o","Section":"List_Section__d2fK+","PettCoupleGroup":"List_PettCoupleGroup__3tUiU","Anouncer":"List_Anouncer__Q0Ig6","ButtonStart":"List_ButtonStart__PT5mA"};